import { Component, Input, OnInit } from '@angular/core';
import { Drive } from 'src/app/services/io/drives/drive';
import { VfmService } from 'src/app/services/io/vfm.service';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { ExplorerManager } from '../../classes/explorer-manager';

@Component({
  selector: 'app-explorer-side-bar',
  templateUrl: './explorer-side-bar.component.html',
  styleUrls: ['./explorer-side-bar.component.scss']
})
export class ExplorerSideBarComponent implements OnInit {
  @Input() explorerManager: ExplorerManager;

  constructor(
    public theme: ThemeService,
    private vfmSv: VfmService) {
  }

  ngOnInit(): void {
  }

  get drives() {
    return this.vfmSv.allDrives;
  }

  getDrive(unit: string): Drive {
    return this.vfmSv.getDrive(unit);
  }

  selectDrive(drive: Drive) {
    this.select(`${drive.unit}:`);
  }

  select(path: string) {
    this.explorerManager.cwd = path;
  }
}
